export const isActiveSonioxClient = <T>(activeClient: T | null, callbackClient: T): boolean =>
  activeClient === callbackClient;

export const createSonioxStartupSignal = () => {
  let resolveStartup: () => void;
  let rejectStartup: (error: Error) => void;
  const promise = new Promise<void>((resolve, reject) => {
    resolveStartup = resolve;
    rejectStartup = reject;
  });

  return {
    promise,
    markStarted: () => resolveStartup(),
    markFailed: (error: Error) => rejectStartup(error),
  };
};
